import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import { colors } from '_styles';
import { _ } from '_locales';
import HOC from '_HOC';

const Container = styled.div`
    width: 100%;
    max-width: 580px;
    padding: 45px 35px;
    box-sizing: border-box;
    margin: 0 auto;
    min-height: 350px;
`;

const Title = styled.h4`
    font-size: 16px;
    font-weight: 500;
    font-family: Roboto, sans-serif;
    color: #747474;

`;

const Description = styled.h4`
    font-size: 16px;
    font-weight: 500;
    font-family: Roboto, sans-serif;
    color: #747474;
    line-height: 1.8em;
`;

const ExitButton = styled.button`
    border: none;
    margin: 0 auto;
    display: block;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer !important;
    color: ${colors.RC_ACTION};
    background-color: transparent;
    text-decoration: underline;
`;

const NotPlacedTimely = ({ props }) => {
  const { location, history } = props;
  const state = location?.state?.state;
  const {
    title = '', description = '', description_2 = '', zoneButton = '', customMsg = ''
  } = location.state;

  const descriptionRef = useRef(null);

  useEffect(() => {
    if (customMsg && descriptionRef.current) {
      const linkElement = descriptionRef.current.getElementsByTagName('a')[0];
      const firstParagraph = descriptionRef.current.getElementsByTagName('p')[0];

      if (linkElement) {
        linkElement.setAttribute('target', '_blank');
        if (firstParagraph) {
          linkElement.setAttribute('aria-label', firstParagraph.innerHTML);
        }
      }
    }
  }, []);

  return (
    <Container>
      {!customMsg.length ? (<Title>{title}</Title>) : null}

      <Description ref={descriptionRef}>
        {customMsg.length ? parse(customMsg) : description}
      </Description>

      {
        description_2.length ? (
          <Description style={{ marginTop: '20px' }}>{description_2}</Description>
        ) : null
      }

      <ExitButton
        onClick={() => ((zoneButton.length) ? history.push('/zone-setup', { ...state }) : history.push('/help'))}
      >
        {(zoneButton.length) ? zoneButton : _('reminder.exit')}
      </ExitButton>
    </Container>
  );
};

export default HOC(NotPlacedTimely);
